import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "../assets/northwind-logo.svg";

const languages = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "es", label: "ES" },
];

function Navbar() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const langMenuRef = useRef(null);

  const handleLanguageSelect = (nextLang) => {
    i18n.changeLanguage(nextLang);
    try {
      localStorage.setItem("lang", nextLang);
    } catch {}
    setIsLangOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!langMenuRef.current) return;
      if (!langMenuRef.current.contains(event.target)) {
        setIsLangOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsLangOpen(false);
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <nav className={`nw-nav ${isScrolled ? "is-scrolled" : ""}`}>
      <div className="nw-nav-inner">
        <a className="nw-brand" href="#top">
          {/* <img src={logo} alt="Northwind Audio logo" className="nw-logo" /> */}
          <span>Northwind Audio</span>
        </a>
        <button
          type="button"
          className="nw-nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <svg
            className="nw-nav-toggle-icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M4 7h16M4 12h16M4 17h16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div className={`nw-nav-links ${isMenuOpen ? "is-open" : ""}`}>
          <a href="#about" onClick={() => setIsMenuOpen(false)}>
            {t("nav.about")}
          </a>
          <a href="#youtube" onClick={() => setIsMenuOpen(false)}>
            {t("nav.youtube")}
          </a>
          <a href="#spotify" onClick={() => setIsMenuOpen(false)}>
            {t("nav.spotify")}
          </a>
          <a href="#contact" onClick={() => setIsMenuOpen(false)}>
            {t("nav.contact")}
          </a>
        </div>
        <div className="nw-nav-actions">
          <div className="nw-lang" ref={langMenuRef}>
            <button
              type="button"
              className="nw-lang-toggle"
              aria-haspopup="listbox"
              aria-expanded={isLangOpen}
              aria-label="Select language"
              onClick={() => setIsLangOpen((open) => !open)}
            >
              <span className="nw-select-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                  <path
                    d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.4 9h-3.1a15.6 15.6 0 00-1.6-5.2A8.03 8.03 0 0119.4 11zM12 4.1c.8 1 1.6 2.9 2 5.9H10c.4-3 1.2-4.9 2-5.9zM4.6 11a8.03 8.03 0 014.7-5.2A15.6 15.6 0 007.7 11H4.6zm0 2h3.1c.3 2.2 1 4.1 1.6 5.2A8.03 8.03 0 014.6 13zM12 19.9c-.8-1-1.6-2.9-2-5.9h4c-.4 3-1.2 4.9-2 5.9zm2.7-1.7c.6-1.1 1.3-3 1.6-5.2h3.1a8.03 8.03 0 01-4.7 5.2z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="nw-lang-label">
                {
                  (
                    languages.find((lang) => lang.code === i18n.language) ||
                    languages[0]
                  ).label
                }
              </span>
              <span className="nw-select-caret" aria-hidden="true" />
            </button>
            <div
              className={`nw-lang-menu ${isLangOpen ? "is-open" : ""}`}
              role="listbox"
            >
              {languages.map((language) => (
                <button
                  key={language.code}
                  type="button"
                  role="option"
                  aria-selected={i18n.language === language.code}
                  className={`nw-lang-option ${
                    i18n.language === language.code ? "is-active" : ""
                  }`}
                  onClick={() => handleLanguageSelect(language.code)}
                >
                  {language.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
